import { createFileRoute } from "@tanstack/react-router"
import { MyProfilesPage } from "@/myprofiles"

// Personal area, not workspace-scoped (product.md §10.3)
export const Route = createFileRoute("/(user)/myprofiles")({
  component: RouteComponent,
})

function RouteComponent() {
  return <MyProfilesPage />
}
